/**
 * @generated SignedSource<<5511031135e1ae4c46d7639a184c4685>>
 * @relayHash f78f34427410c75b03c69376f28bcc6c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eee2c935fbb7dd87bf9fe85b6c9959dceaa48c3a2f6c2317cb9a0e584d5003e7

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggListQuery$variables = {
  cypherQuery: string;
  first: number;
  isEnabled: boolean;
  queryContext: string;
};
export type AggListQuery$data = {
  readonly graphStore?: {
    readonly cypherQueryV2: {
      readonly " $fragmentSpreads": FragmentRefs<"generateListFromCypher">;
    };
  } | null;
};
export type AggListQuery = {
  response: AggListQuery$data;
  variables: AggListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cypherQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "cypherQuery"
  },
  {
    "kind": "Variable",
    "name": "queryContext",
    "variableName": "queryContext"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "title"
},
v8 = [
  {
    "kind": "ScalarField",
    "name": "webUi"
  },
  {
    "kind": "ScalarField",
    "name": "base"
  }
],
v9 = {
  "concreteType": "ConfluencePageLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v8/*: any*/)
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "concreteType": "ConfluenceSpaceLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v8/*: any*/)
},
v12 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/)
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v14 = {
  "kind": "ScalarField",
  "name": "favoritedAt"
},
v15 = {
  "kind": "ScalarField",
  "name": "isFavorite"
},
v16 = [
  {
    "concreteType": "ConfluenceFavoritedSummary",
    "kind": "LinkedField",
    "name": "favoritedSummary",
    "plural": false,
    "selections": [
      (v14/*: any*/),
      (v15/*: any*/),
      {
        "kind": "FragmentSpread",
        "name": "confluenceItemActions_favoritedUpdatable"
      },
      {
        "kind": "InlineDataFragmentSpread",
        "name": "confluenceItemActions_favorited",
        "selections": [
          (v15/*: any*/)
        ],
        "argumentDefinitions": ([]/*: any*/)
      }
    ]
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "value"
},
v18 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiPublished",
      "plural": false,
      "selections": [
        (v17/*: any*/)
      ]
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v20 = {
  "concreteType": "ConfluenceBlogPostLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v8/*: any*/)
},
v21 = {
  "concreteType": "ConfluenceWhiteboardLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v8/*: any*/)
},
v22 = {
  "concreteType": "ConfluenceContentVersion",
  "kind": "LinkedField",
  "name": "latestVersion",
  "plural": false,
  "selections": [
    (v13/*: any*/)
  ]
},
v23 = {
  "concreteType": "ConfluenceContentViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v16/*: any*/)
},
v24 = {
  "concreteType": "ConfluenceDatabaseLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v8/*: any*/)
},
v25 = {
  "kind": "ScalarField",
  "name": "url"
},
v26 = [
  (v17/*: any*/),
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v27 = {
  "alias": "projectState",
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v26/*: any*/)
},
v28 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v29 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v30 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v31 = [
  (v29/*: any*/),
  (v30/*: any*/)
],
v32 = {
  "alias": "goalState",
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v26/*: any*/)
},
v33 = [
  (v6/*: any*/),
  {
    "kind": "ScalarField",
    "name": "displayName"
  },
  (v25/*: any*/),
  {
    "kind": "ScalarField",
    "name": "status"
  },
  {
    "kind": "ScalarField",
    "name": "lastUpdate"
  },
  {
    "concreteType": "ExternalUser",
    "kind": "LinkedField",
    "name": "owners",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "userId"
      }
    ]
  }
],
v34 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v6/*: any*/)
  ]
},
v35 = [
  {
    "concreteType": "ConfluenceFavoritedSummary",
    "kind": "LinkedField",
    "name": "favoritedSummary",
    "plural": false,
    "selections": [
      (v14/*: any*/),
      (v15/*: any*/),
      (v5/*: any*/)
    ]
  }
],
v36 = {
  "concreteType": "ConfluenceContentViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v35/*: any*/)
},
v37 = [
  (v29/*: any*/),
  (v30/*: any*/),
  (v6/*: any*/)
],
v38 = [
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggListQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "generateListFromCypher",
                    "selections": [
                      {
                        "concreteType": "GraphStoreCypherQueryV2Edge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "GraphStoreCypherQueryV2Node",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreCypherQueryV2Column",
                                "kind": "LinkedField",
                                "name": "columns",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateConfluencePageItem",
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      (v7/*: any*/),
                                                      (v9/*: any*/),
                                                      (v12/*: any*/),
                                                      (v13/*: any*/),
                                                      {
                                                        "concreteType": "ConfluencePageViewerSummary",
                                                        "kind": "LinkedField",
                                                        "name": "viewer",
                                                        "plural": false,
                                                        "selections": (v16/*: any*/)
                                                      },
                                                      (v18/*: any*/),
                                                      (v19/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ConfluencePage"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateConfluenceBlogPostItem",
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      (v7/*: any*/),
                                                      (v20/*: any*/),
                                                      (v12/*: any*/),
                                                      (v13/*: any*/),
                                                      {
                                                        "concreteType": "ConfluenceBlogPostViewerSummary",
                                                        "kind": "LinkedField",
                                                        "name": "viewer",
                                                        "plural": false,
                                                        "selections": (v16/*: any*/)
                                                      },
                                                      (v18/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ConfluenceBlogPost"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateConfluenceWhiteboardItem",
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      (v7/*: any*/),
                                                      (v21/*: any*/),
                                                      (v12/*: any*/),
                                                      (v22/*: any*/),
                                                      (v23/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ConfluenceWhiteboard"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateConfluenceDatabaseItem",
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      (v7/*: any*/),
                                                      (v24/*: any*/),
                                                      (v12/*: any*/),
                                                      (v22/*: any*/),
                                                      (v23/*: any*/)
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ConfluenceDatabase"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateTownsquareProjectItem",
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      (v10/*: any*/),
                                                      (v25/*: any*/),
                                                      (v27/*: any*/),
                                                      {
                                                        "alias": "projectUpdates",
                                                        "args": (v28/*: any*/),
                                                        "concreteType": "TownsquareProjectUpdateConnection",
                                                        "kind": "LinkedField",
                                                        "name": "updates",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareProjectUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "concreteType": "TownsquareProjectUpdate",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v31/*: any*/)
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "updates(first:1)"
                                                      }
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "TownsquareProject"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateTownsquareGoalItem",
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      (v10/*: any*/),
                                                      (v25/*: any*/),
                                                      (v32/*: any*/),
                                                      {
                                                        "alias": "goalUpdates",
                                                        "args": (v28/*: any*/),
                                                        "concreteType": "TownsquareGoalUpdateConnection",
                                                        "kind": "LinkedField",
                                                        "name": "updates",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareGoalUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "concreteType": "TownsquareGoalUpdate",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v31/*: any*/)
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "updates(first:1)"
                                                      }
                                                    ],
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "TownsquareGoal"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "generateExternalPullRequestItem",
                                                    "selections": (v33/*: any*/),
                                                    "argumentDefinitions": []
                                                  }
                                                ],
                                                "type": "ExternalPullRequest"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "GraphStoreCypherQueryV2AriNode"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "argumentDefinitions": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggListQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreCypherQueryV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GraphStoreCypherQueryV2Node",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreCypherQueryV2Column",
                            "kind": "LinkedField",
                            "name": "columns",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v6/*: any*/),
                                              (v7/*: any*/),
                                              (v9/*: any*/),
                                              (v34/*: any*/),
                                              (v13/*: any*/),
                                              {
                                                "concreteType": "ConfluencePageViewerSummary",
                                                "kind": "LinkedField",
                                                "name": "viewer",
                                                "plural": false,
                                                "selections": (v35/*: any*/)
                                              },
                                              (v18/*: any*/),
                                              (v19/*: any*/)
                                            ],
                                            "type": "ConfluencePage"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v6/*: any*/),
                                              (v7/*: any*/),
                                              (v20/*: any*/),
                                              (v34/*: any*/),
                                              (v13/*: any*/),
                                              {
                                                "concreteType": "ConfluenceBlogPostViewerSummary",
                                                "kind": "LinkedField",
                                                "name": "viewer",
                                                "plural": false,
                                                "selections": (v35/*: any*/)
                                              },
                                              (v18/*: any*/)
                                            ],
                                            "type": "ConfluenceBlogPost"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v6/*: any*/),
                                              (v7/*: any*/),
                                              (v21/*: any*/),
                                              (v34/*: any*/),
                                              (v22/*: any*/),
                                              (v36/*: any*/)
                                            ],
                                            "type": "ConfluenceWhiteboard"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v6/*: any*/),
                                              (v7/*: any*/),
                                              (v24/*: any*/),
                                              (v34/*: any*/),
                                              (v22/*: any*/),
                                              (v36/*: any*/)
                                            ],
                                            "type": "ConfluenceDatabase"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v6/*: any*/),
                                              (v10/*: any*/),
                                              (v25/*: any*/),
                                              (v27/*: any*/),
                                              {
                                                "alias": "projectUpdates",
                                                "args": (v28/*: any*/),
                                                "concreteType": "TownsquareProjectUpdateConnection",
                                                "kind": "LinkedField",
                                                "name": "updates",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareProjectUpdateEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareProjectUpdate",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": (v37/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "updates(first:1)"
                                              }
                                            ],
                                            "type": "TownsquareProject"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v6/*: any*/),
                                              (v10/*: any*/),
                                              (v25/*: any*/),
                                              (v32/*: any*/),
                                              {
                                                "alias": "goalUpdates",
                                                "args": (v28/*: any*/),
                                                "concreteType": "TownsquareGoalUpdateConnection",
                                                "kind": "LinkedField",
                                                "name": "updates",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareGoalUpdateEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareGoalUpdate",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": (v37/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "updates(first:1)"
                                              }
                                            ],
                                            "type": "TownsquareGoal"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v33/*: any*/),
                                            "type": "ExternalPullRequest"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "AppUser"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "AtlassianAccountUser"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "CustomerUser"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "DevOpsFeatureFlag"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "DevOpsOperationsComponentDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "DevOpsOperationsIncidentDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "DevOpsProjectDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "DevOpsPullRequestDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "DevOpsRepository"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "JiraAutodevJob"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "JiraConfluenceRemoteIssueLink"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "JiraCustomRemoteIssueLink"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "JiraIssueRemoteIssueLink"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "JiraWebRemoteIssueLink"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v38/*: any*/),
                                            "type": "ThirdPartyUser"
                                          }
                                        ]
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "type": "GraphStoreCypherQueryV2AriNode"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f78f34427410c75b03c69376f28bcc6c",
    "id": "eee2c935fbb7dd87bf9fe85b6c9959dceaa48c3a2f6c2317cb9a0e584d5003e7",
    "metadata": {},
    "name": "AggListQuery",
    "operationKind": "query",
    "text": "query AggListQuery(\n  $cypherQuery: String!\n  $queryContext: String!\n  $isEnabled: Boolean!\n  $first: Int!\n) {\n  graphStore @include(if: $isEnabled) @optIn(to: \"GraphStore\") {\n    cypherQueryV2(query: $cypherQuery, queryContext: $queryContext, first: $first) @optIn(to: \"GraphStoreCypherQueryV2\") {\n      ...generateListFromCypher\n    }\n  }\n}\n\nfragment confluenceItemActions_favorited on ConfluenceFavoritedSummary {\n  isFavorite\n}\n\nfragment generateConfluenceBlogPostItem on ConfluenceBlogPost {\n  id\n  title\n  links {\n    webUi\n    base\n  }\n  space {\n    name\n    links {\n      webUi\n      base\n    }\n    id\n  }\n  createdAt\n  viewer {\n    favoritedSummary {\n      favoritedAt\n      isFavorite\n      __typename\n      ...confluenceItemActions_favorited\n    }\n  }\n  metadata {\n    titleEmojiPublished {\n      value\n    }\n  }\n}\n\nfragment generateConfluenceDatabaseItem on ConfluenceDatabase {\n  id\n  title\n  links {\n    webUi\n    base\n  }\n  space {\n    name\n    links {\n      webUi\n      base\n    }\n    id\n  }\n  latestVersion {\n    createdAt\n  }\n  viewer {\n    favoritedSummary {\n      favoritedAt\n      isFavorite\n      __typename\n      ...confluenceItemActions_favorited\n    }\n  }\n}\n\nfragment generateConfluencePageItem on ConfluencePage {\n  id\n  title\n  links {\n    webUi\n    base\n  }\n  space {\n    name\n    links {\n      webUi\n      base\n    }\n    id\n  }\n  createdAt\n  viewer {\n    favoritedSummary {\n      favoritedAt\n      isFavorite\n      __typename\n      ...confluenceItemActions_favorited\n    }\n  }\n  metadata {\n    titleEmojiPublished {\n      value\n    }\n  }\n  subtype\n}\n\nfragment generateConfluenceWhiteboardItem on ConfluenceWhiteboard {\n  id\n  title\n  links {\n    webUi\n    base\n  }\n  space {\n    name\n    links {\n      webUi\n      base\n    }\n    id\n  }\n  latestVersion {\n    createdAt\n  }\n  viewer {\n    favoritedSummary {\n      favoritedAt\n      isFavorite\n      __typename\n      ...confluenceItemActions_favorited\n    }\n  }\n}\n\nfragment generateExternalPullRequestItem on ExternalPullRequest {\n  id\n  displayName\n  url\n  status\n  lastUpdate\n  owners {\n    userId\n  }\n}\n\nfragment generateListFromCypher on GraphStoreCypherQueryV2Connection {\n  edges {\n    node {\n      columns {\n        value {\n          __typename\n          ... on GraphStoreCypherQueryV2AriNode {\n            data {\n              __typename\n              ... on ConfluencePage {\n                __typename\n                ...generateConfluencePageItem\n              }\n              ... on ConfluenceBlogPost {\n                __typename\n                ...generateConfluenceBlogPostItem\n              }\n              ... on ConfluenceWhiteboard {\n                __typename\n                ...generateConfluenceWhiteboardItem\n              }\n              ... on ConfluenceDatabase {\n                __typename\n                ...generateConfluenceDatabaseItem\n              }\n              ... on TownsquareProject {\n                __typename\n                ...generateTownsquareProjectItem\n              }\n              ... on TownsquareGoal {\n                __typename\n                ...generateTownsquareGoalItem\n              }\n              ... on ExternalPullRequest {\n                __typename\n                ...generateExternalPullRequestItem\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on AppUser {\n                id\n              }\n              ... on AtlassianAccountUser {\n                id\n              }\n              ... on CustomerUser {\n                id\n              }\n              ... on DevOpsFeatureFlag {\n                id\n              }\n              ... on DevOpsOperationsComponentDetails {\n                id\n              }\n              ... on DevOpsOperationsIncidentDetails {\n                id\n              }\n              ... on DevOpsOperationsPostIncidentReviewDetails {\n                id\n              }\n              ... on DevOpsProjectDetails {\n                id\n              }\n              ... on DevOpsPullRequestDetails {\n                id\n              }\n              ... on DevOpsRepository {\n                id\n              }\n              ... on DevOpsSecurityVulnerabilityDetails {\n                id\n              }\n              ... on JiraAutodevJob {\n                id\n              }\n              ... on JiraConfluenceRemoteIssueLink {\n                id\n              }\n              ... on JiraCustomRemoteIssueLink {\n                id\n              }\n              ... on JiraIssueRemoteIssueLink {\n                id\n              }\n              ... on JiraWebRemoteIssueLink {\n                id\n              }\n              ... on ThirdPartyUser {\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment generateTownsquareGoalItem on TownsquareGoal {\n  id\n  name\n  url\n  goalState: state {\n    value\n    label\n  }\n  goalUpdates: updates(first: 1) @optIn(to: \"Townsquare\") {\n    edges {\n      node {\n        creationDate\n        editDate\n        id\n      }\n    }\n  }\n}\n\nfragment generateTownsquareProjectItem on TownsquareProject {\n  id\n  name\n  url\n  projectState: state {\n    value\n    label\n  }\n  projectUpdates: updates(first: 1) @optIn(to: \"Townsquare\") {\n    edges {\n      node {\n        creationDate\n        editDate\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1e1a66be32d4fe6d37befe153f52057";

export default node;
